// type
import { FC, PropsWithChildren } from "react";
import { Toaster } from "sonner";

export const NotificationProvider: FC<PropsWithChildren> = (props) => {
  const { children } = props;
  return (
    <>
      <Toaster
        duration={3 * 1000}
        richColors
        theme="light"
        position="top-center"
        closeButton
        visibleToasts={4}
      />
      {children}
    </>
    // <SnackbarProvider maxSnack={5} autoHideDuration={5 * 1000}>{children}</SnackbarProvider>
  );
};
